/* ============================================================
   Enhanced Country Modal Search
   - Multi-language smart matching (Chinese, Japanese, Korean, country codes)
   - Enter key handling (prevent default, highlight first match)
   - Match highlighting in results
   - Match count display
   ============================================================ */
(function() {
  var COUNTRY_ALIASES = {
    'austria': ['奥地利','オーストリア','AT'],
    'belgium': ['比利时','ベルギー','BE'],
    'bulgaria': ['保加利亚','ブルガリア','BG'],
    'croatia': ['克罗地亚','クロアチア','HR'],
    'cyprus': ['塞浦路斯','キプロス','CY'],
    'czech republic': ['捷克','チェコ','CZ'],
    'czechia': ['捷克','チェコ','CZ'],
    'denmark': ['丹麦','デンマーク','DK'],
    'estonia': ['爱沙尼亚','エストニア','EE'],
    'finland': ['芬兰','フィンランド','FI'],
    'france': ['法国','フランス','FR'],
    'germany': ['德国','ドイツ','DE'],
    'greece': ['希腊','ギリシャ','GR'],
    'hungary': ['匈牙利','ハンガリー','HU'],
    'iceland': ['冰岛','アイスランド','IS'],
    'ireland': ['爱尔兰','アイルランド','IE'],
    'italy': ['意大利','イタリア','IT'],
    'latvia': ['拉脱维亚','ラトビア','LV'],
    'liechtenstein': ['列支敦士登','リヒテンシュタイン','LI'],
    'lithuania': ['立陶宛','リトアニア','LT'],
    'luxembourg': ['卢森堡','ルクセンブルク','LU'],
    'malta': ['马耳他','マルタ','MT'],
    'netherlands': ['荷兰','オランダ','NL'],
    'norway': ['挪威','ノルウェー','NO'],
    'poland': ['波兰','ポーランド','PL'],
    'portugal': ['葡萄牙','ポルトガル','PT'],
    'romania': ['罗马尼亚','ルーマニア','RO'],
    'slovakia': ['斯洛伐克','スロバキア','SK'],
    'slovenia': ['斯洛文尼亚','スロベニア','SI'],
    'spain': ['西班牙','スペイン','ES'],
    'sweden': ['瑞典','スウェーデン','SE'],
    'switzerland': ['瑞士','スイス','CH'],
    'united kingdom': ['英国','イギリス','GB','UK'],
    'uk': ['英国','イギリス','GB'],
    'turkey': ['土耳其','トルコ','TR'],
    'ukraine': ['乌克兰','ウクライナ','UA'],
    'albania': ['阿尔巴尼亚','アルバニア','AL'],
    'jersey': ['泽西岛','ジャージー','JE'],
    'gibraltar': ['直布罗陀','ジブラルタル','GI'],
    'japan': ['日本','JP'],
    'south korea': ['韩国','한국','KR'],
    'korea': ['韩国','한국','KR'],
    'china': ['中国','中國','CN'],
    'hong kong': ['香港','ホンコン','HK'],
    'taiwan': ['台湾','台灣','TW'],
    'thailand': ['泰国','タイ','TH'],
    'singapore': ['新加坡','シンガポール','SG'],
    'malaysia': ['马来西亚','マレーシア','MY'],
    'indonesia': ['印度尼西亚','印尼','インドネシア','ID'],
    'vietnam': ['越南','ベトナム','VN'],
    'philippines': ['菲律宾','フィリピン','PH'],
    'india': ['印度','インド','IN'],
    'australia': ['澳大利亚','澳洲','オーストラリア','AU'],
    'new zealand': ['新西兰','ニュージーランド','NZ'],
    'united states': ['美国','アメリカ','US','USA'],
    'usa': ['美国','アメリカ','US'],
    'canada': ['加拿大','カナダ','CA'],
    'mexico': ['墨西哥','メキシコ','MX'],
    'brazil': ['巴西','ブラジル','BR'],
    'russia': ['俄罗斯','ロシア','RU'],
    'south africa': ['南非','南アフリカ','ZA'],
    'egypt': ['埃及','エジプト','EG'],
    'israel': ['以色列','イスラエル','IL'],
    'saudi arabia': ['沙特阿拉伯','サウジアラビア','SA'],
    'uae': ['阿联酋','UAE','AE'],
    'europe': ['欧洲','ヨーロッパ','EU'],
    'asia': ['亚洲','アジア'],
    'africa': ['非洲','アフリカ'],
    'america': ['美洲','アメリカ'],
    'global': ['全球','グローバル']
  };

  function initEnhancedSearch() {
    var searchInput = document.getElementById('country-search');
    var countryList = document.getElementById('country-list');
    var errorMsg = document.getElementById('country-error');
    if (!searchInput || !countryList) return;

    // Build reverse alias map: alias -> [original country names]
    var aliasMap = {};
    Object.keys(COUNTRY_ALIASES).forEach(function(eng) {
      var aliases = COUNTRY_ALIASES[eng];
      aliases.forEach(function(alias) {
        var key = alias.toLowerCase();
        if (!aliasMap[key]) aliasMap[key] = [];
        aliasMap[key].push(eng);
      });
    });

    // Cache country items data
    var items = countryList.querySelectorAll('li');
    var itemData = [];
    items.forEach(function(item) {
      var text = item.textContent || '';
      var isHeader = item.style.fontWeight === 'bold' ||
                     item.style.fontWeight === '700' ||
                     text.match(/^[A-Z\s()&,]+$/);
      itemData.push({
        el: item,
        text: text,
        lowerText: text.toLowerCase(),
        originalHTML: item.innerHTML,
        isHeader: isHeader
      });
    });

    // Smart match function
    function smartMatch(query, itemText) {
      var q = query.toLowerCase().trim();
      if (!q) return true;

      // Direct substring match
      if (itemText.toLowerCase().indexOf(q) !== -1) return true;

      // Check if query matches any alias
      var matchedEnglish = [];
      Object.keys(aliasMap).forEach(function(alias) {
        if (alias.indexOf(q) !== -1 || q.indexOf(alias) !== -1) {
          matchedEnglish = matchedEnglish.concat(aliasMap[alias]);
        }
      });

      // Also check direct country code/name in COUNTRY_ALIASES keys
      Object.keys(COUNTRY_ALIASES).forEach(function(eng) {
        if (eng.indexOf(q) !== -1) {
          matchedEnglish.push(eng);
        }
      });

      // Check if item text contains any matched English name
      var itemLower = itemText.toLowerCase();
      for (var i = 0; i < matchedEnglish.length; i++) {
        if (itemLower.indexOf(matchedEnglish[i]) !== -1) return true;
        // Also try partial word match
        var words = matchedEnglish[i].split(' ');
        for (var j = 0; j < words.length; j++) {
          if (words[j].length > 2 && itemLower.indexOf(words[j]) !== -1) return true;
        }
      }

      return false;
    }

    // Highlight matching text
    function highlightText(originalHTML, query) {
      if (!query || query.length < 1) return originalHTML;
      var q = query.trim();
      // Try to highlight the direct match in the text
      var regex = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      return originalHTML.replace(regex, '<mark style="background:#fef08a;padding:0 1px;border-radius:2px">$1</mark>');
    }

    // Create match count element
    var matchCount = document.createElement('div');
    matchCount.id = 'country-match-count';
    matchCount.style.cssText = 'font-size:12px;color:#6b7280;margin:-10px 0 10px;padding:0 4px;display:none';
    searchInput.parentNode.insertBefore(matchCount, searchInput.nextSibling);

    // Enhanced filter function
    function filterList() {
      var query = searchInput.value.trim();
      var visibleCount = 0;
      var firstMatch = null;

      itemData.forEach(function(data) {
        if (data.isHeader) {
          // Headers: show only if query is empty
          data.el.style.display = query === '' ? 'flex' : 'none';
          return;
        }

        if (query === '') {
          data.el.style.display = 'flex';
          data.el.innerHTML = data.originalHTML;
          visibleCount++;
        } else if (smartMatch(query, data.text)) {
          data.el.style.display = 'flex';
          data.el.innerHTML = highlightText(data.originalHTML, query);
          visibleCount++;
          if (!firstMatch) firstMatch = data.el;
        } else {
          data.el.style.display = 'none';
          data.el.innerHTML = data.originalHTML;
        }
      });

      // Show/hide error
      if (errorMsg) {
        errorMsg.style.display = (visibleCount === 0 && query !== '') ? 'block' : 'none';
      }

      // Update match count
      if (query !== '') {
        matchCount.textContent = visibleCount > 0
          ? visibleCount + ' ' + (visibleCount === 1 ? 'country found' : 'countries found')
          : '';
        matchCount.style.display = visibleCount > 0 ? 'block' : 'none';
      } else {
        matchCount.style.display = 'none';
      }

      return firstMatch;
    }

    // Override the existing input handler
    searchInput.addEventListener('input', function(e) {
      // Stop the original handler by stopping propagation is not possible
      // since both are on the same element. But our handler runs after theirs
      // and re-processes all items. This effectively overrides the result.
      filterList();
    });

    // Handle Enter key
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        var firstMatch = filterList();
        if (firstMatch) {
          // Scroll to and briefly highlight the first match
          firstMatch.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          firstMatch.style.backgroundColor = '#fef08a';
          setTimeout(function() { firstMatch.style.backgroundColor = ''; }, 1200);
        }
      }
    });

    // Update placeholder to indicate multi-language support
    var lang = document.documentElement.lang || '';
    if (lang.indexOf('ja') !== -1) {
      searchInput.placeholder = '国名を検索（日本語・英語対応）';
    } else if (lang.indexOf('zh') !== -1) {
      searchInput.placeholder = '搜索国家（支持中文、英文、国家代码）';
    } else if (lang.indexOf('ko') !== -1) {
      searchInput.placeholder = '국가 검색 (한국어, 영어 지원)';
    } else {
      searchInput.placeholder = 'Search country (supports multiple languages)';
    }
  }

  // Initialize after a short delay to ensure original script has run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initEnhancedSearch, 200);
    });
  } else {
    setTimeout(initEnhancedSearch, 200);
  }
})();
